module.exports = __webpack_public_path__ + "static/media/icon_cardboard2.25cbc899.svg";